import type { TranslatedString } from './shared';
export type FeatureFlagOption = {
  type?: string;
  enabled?: boolean;
};

export type OrganizationFeatureFlag = {
  id?: string;
  featureFlags?: FeatureFlagOption[];
};

export type FeatureFlag = {
  value?: string;
  group?: string;
  translatedDescription?: TranslatedString;
};

export enum FeatureFlagTypes {
  CASH_JOINT = 'CASH_JOINT',
  CORPORATE_ACCOUNTS = 'CORPORATE_ACCOUNTS',
  GRSP = 'GRSP',
  LIF = 'LIF',
  LIRA = 'LIRA',
  PRIF = 'PRIF',
  RDSP = 'RDSP',
  RESP = 'RESP',
  RESP_SINGLE = 'RESP_SINGLE',
  RESP_FAMILY = 'RESP_FAMILY',
  RESP_ADULT = 'RESP_ADULT',
  RIF_SPOUSAL = 'RIF_SPOUSAL',
  RRIF = 'RRIF',
  RRSP_SPOUSAL = 'RRSP_SPOUSAL',
  TAX_LOSS_HARVESTING = 'TAX_LOSS_HARVESTING',
  FIX_TRADING = 'FIX_TRADING',
  MANUALLY_ADD_BANK_ACCOUNT = 'MANUALLY_ADD_BANK_ACCOUNT',
  DEPOSITS = 'DEPOSITS',
  WITHDRAWALS = 'WITHDRAWALS',
  AUTO_INVESTMENTS = 'AUTO_INVESTMENTS',
  CREATE_NEW_GOALS = 'CREATE_NEW_GOALS',
  CREATE_NEW_SUB_ACCOUNTS = 'CREATE_NEW_SUB_ACCOUNTS',
  UPDATE_GOAL = 'UPDATE_GOAL',
  UPDATE_SUB_ACCOUNT = 'UPDATE_SUB_ACCOUNT',
  CLOSE_ACCOUNT = 'CLOSE_ACCOUNT',
  UPDATE_PERSONAL_DETAILS = 'UPDATE_PERSONAL_DETAILS',
  VIEW_HELP_CENTER = 'VIEW_HELP_CENTER',
  VIEW_STATEMENTS = 'VIEW_STATEMENTS',
  VIEW_TAX_DOCUMENTS = 'VIEW_TAX_DOCUMENTS',
  VIEW_AGREEMENTS = 'VIEW_AGREEMENTS',
  ID_VERIFICATION = 'ID_VERIFICATION',
  ACCOUNT_TO_ACCOUNT_DEPOSIT = 'ACCOUNT_TO_ACCOUNT_DEPOSIT',
  RESP_FAMILY_JOINT = 'RESP_FAMILY_JOINT',
  RESP_SINGLE_JOINT = 'RESP_SINGLE_JOINT',
  RLSP = 'RLSP',
  LRSP = 'LRSP',
  RLIF = 'RLIF',
  LRIF = 'LRIF',
  ANNUAL_INFORMATION_UPDATE = 'ANNUAL_INFORMATION_UPDATE',
  SUITABILITY_REVIEW_DUE_NOTIFICATIONS = 'SUITABILITY_REVIEW_DUE_NOTIFICATIONS',
  SUITABILITY_REVIEW_OVERDUE_BLOCK_TRANSFERS = 'SUITABILITY_REVIEW_OVERDUE_BLOCK_TRANSFERS',
  PAD_AGREEMENTS = 'PAD_AGREEMENTS',
  BLOCK_CLIENT_SIGN_UP = 'BLOCK_CLIENT_SIGN_UP',
  AUTOMATED_BANK_ACCOUNT_LINKING = 'AUTOMATED_BANK_ACCOUNT_LINKING',
  DRIFT_TOLERANCE_ENABLED = 'DRIFT_TOLERANCE_ENABLED',
  TFSA = 'TFSA',
  FHSA = 'FHSA',
  RRSP = 'RRSP',
  PERSONAL = 'PERSONAL',
  ADVISOR_APPROVAL_REQUIRED_FOR_CLIENTS_TO_SIGN_AGREEMENTS = 'ADVISOR_APPROVAL_REQUIRED_FOR_CLIENTS_TO_SIGN_AGREEMENTS',
  HOUSEHOLD = 'HOUSEHOLD',
  ASSET_CLASSES = 'ASSET_CLASSES',
  DOCUMENTS = 'DOCUMENTS',
  DOCUMENTS_WIDGET_ENHANCEMENTS = 'DOCUMENTS_WIDGET_ENHANCEMENTS',
  AUTHORIZED_ACCOUNT_ACCESS = 'AUTHORIZED_ACCOUNT_ACCESS',
  CUSTODIAN_STATEMENT = 'CUSTODIAN_STATEMENT',
  ONEVEST_STATEMENT = 'ONEVEST_STATEMENT',
  BYPASS_ID_VERIFICATION = 'BYPASS_ID_VERIFICATION',
  ALLOW_ADDING_A_NEW_PROFILE = 'ALLOW_ADDING_A_NEW_PROFILE',
  IN_KIND_TRANSFERS = 'IN_KIND_TRANSFERS',
  MODEL_PORTFOLIOS_V2 = 'MODEL_PORTFOLIOS_V2',
  US_TRANSFER_FLOW = 'US_TRANSFER_FLOW',
  ADD_INSTITUTIONS_MANUALLY_IN_UCE = 'ADD_INSTITUTIONS_MANUALLY_IN_UCE',
  JOINT_AFFILIATE_CONFIGURATIONS = 'JOINT_AFFILIATE_CONFIGURATIONS',
  AFFILIATE_CONVERSION_CONFIGURATIONS = 'AFFILIATE_CONVERSION_CONFIGURATIONS',
  MULTI_CURRENCY_DEPOSIT_TRANSFERS = 'MULTI_CURRENCY_DEPOSIT_TRANSFERS',
  MULTI_CURRENCY_WITHDRAW_TRANSFERS = 'MULTI_CURRENCY_WITHDRAW_TRANSFERS',
  CREATE_ACCOUNT_OR_SUB_ACCOUNT_CONFIG = 'CREATE_ACCOUNT_OR_SUB_ACCOUNT_CONFIG',
  GOAL_CREATION_METHOD = 'GOAL_CREATION_METHOD',
  ALL_ACCOUNT_EDIT_IN_REVIEW = 'ALL_ACCOUNT_EDIT_IN_REVIEW',
  ACCOUNT_GROUPS = 'ACCOUNT_GROUPS',
  TRANSLATED_ATTRIBUTES = 'TRANSLATED_ATTRIBUTES',
  MANUAL_NET_WORTH_LINKING = 'MANUAL_NET_WORTH_LINKING',
  AUTOMATIC_NET_WORTH_LINKING = 'AUTOMATIC_NET_WORTH_LINKING',
  WORKFLOW_ENHANCEMENTS = 'WORKFLOW_ENHANCEMENTS',
  PAGE_CONFIGURATION_ENHANCEMENTS = 'PAGE_CONFIGURATION_ENHANCEMENTS',
}
